import { Node } from 'prosemirror-to-html-js';

export default class ParagraphSimple extends Node {
  matching () {
    return this.node.type === "paragraph";
  }

  tag () {
    return [
      {
        tag: "p"
      }
    ]
  }
}
